import React from "react";
import { Box } from "@chakra-ui/react";
import { TextItemNode } from "./TextItemNode";
import { HtmlItemNode } from "./HtmlItemNode";
import { LinkItemNode } from "./LinkItemNode";
import { ImageItemNode } from "./ImageItemNode";
import { DownloadItemNode } from "./DownloadItemNode";
import { VideoItemNode } from "./VideoItemNode";

export const ItemNode = (props) => {
  let contentSegment = null;

  switch (props.item.type.toLowerCase()) {
    case "text": {
      contentSegment = (
        <TextItemNode content={props.item.content} format={props.item.format} />
      );
      break;
    }
    case "image": {
      contentSegment = (
        <ImageItemNode
          file={props.item.imageFile}
          title={props.item.description}
          altText={props.item.altText}
          instructionKey={props.instructionKey}
        />
      );
      break;
    }
    case "link": {
      contentSegment = (
        <LinkItemNode
          description={props.item.description}
          location={props.item.location}
        />
      );
      break;
    }
    case "download": {
      contentSegment = (
        <DownloadItemNode
          file={props.item.file}
          description={props.item.description}
          instructionKey={props.instructionKey}
        />
      );
      break;
    }
    case "html": {
      contentSegment = <HtmlItemNode content={props.item.content} />;
      break;
    }
    case "video": {
      contentSegment = (
        <VideoItemNode
          description={props.item.description}
          location={props.item.location}
          duration={props.item.duration}
        />
      );
      break;
    }
    default: {
      break;
    }
  }

  return contentSegment !== null ? <Box pt={2}>{contentSegment}</Box> : "";
};
